import { Outlet, useLoaderData } from 'react-router-dom';

export function AdminContainer() {
  const renderContext = useLoaderData();
  return (
    <div
      id='main-content'
      className='relative h-auto min-h-[100dvh] w-full overflow-y-auto bg-slate-100 p-3'
    >
      <main className='h-full w-full'>
        <Outlet context={renderContext} />
      </main>
    </div>
  );
}
